import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ENDPOINTS, buildApiUrl } from '../../constants/apiendpoints.constant';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  title: string = '';
  jarmixProductListData: any;
  jarmixTotalCarrierMl: any;
  jarmixTotalCarrierFloz: any;
  jarmixJarVolumeValue: any;
  jarmixSprayVolumeValue: any;
  selectedJarVolumeUnit: any;
  premixShow: boolean = true;
  jarmixShow: boolean = false;
  techGuideShow: boolean = false;
  atsShow: boolean = false;
  programBuilderShow: boolean = false;
  resistanceShow: boolean = false;
  activeIndex: number = 0;
  constructor(private http: HttpClient) { }
  //getters and setters for the JarmixCalculator field values to retain the state on tab switch
  setProductList = (data: any) => this.jarmixProductListData = data;
  setSelectedJarVolumeUnit = (data: any) => this.selectedJarVolumeUnit = data;
  setJarVolumeValue = (data: any) => this.jarmixJarVolumeValue = data;
  setSprayVolumeValue = (data: any) => this.jarmixSprayVolumeValue = data;
  setTotalCarrierFloz = (data: any) => this.jarmixTotalCarrierFloz = data;
  setTotalCarrierMl = (data: any) => this.jarmixTotalCarrierMl = data;

  getProductList = () => this.jarmixProductListData;
  getSelectedJarVolumeUnit = () => this.selectedJarVolumeUnit;
  getJarVolumeValue = () => this.jarmixJarVolumeValue;
  getSprayVolumeValue = () => this.jarmixSprayVolumeValue;
  getTotalCarrierFloz = () => this.jarmixTotalCarrierFloz;
  getTotalCarrierMl = () => this.jarmixTotalCarrierMl;

  postLoginTokenForCMS(): Observable<any> {
    return this.http.post<any>(buildApiUrl(API_ENDPOINTS.AUTH.LOGIN), environment.api.credentials)
  }
  getPageData(): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.GET_PAGE_DATA);
    return this.http.get<any>(appURL);
  }
  getPremixLegalText(): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.GET_LEGAL);
    return this.http.get<any>(appURL);
  }
  saveCompany(companyName: string): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.SAVE_COMPANY) + '/' + companyName;
    return this.http.post<any>(appURL, companyName);
  }
  savePremix(premixData: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.SAVE_PREMIX_DATA);
    return this.http.post<any>(appURL, premixData);
  }
  getPremix(premixId: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.GET_PREMIX_DATA);
    return this.http.get<any>(appURL + '/' + premixId);
  }
  DeletePremix(premixId: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.DELETE_PREMIX) + '/' + premixId;
    return this.http.post<any>(appURL, premixId);
  }
  deleteActiveIngredient(activeIngrdientId: any, product_id: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.DELETE_ACTIVE_INGREDIENT) + '/' + activeIngrdientId + '/' + product_id;
    return this.http.post<any>(appURL, activeIngrdientId);
  }
  saveActiveIngredient(activeIngredientDetails: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.SAVE_ACTIVE_INGREDIENT);
    return this.http.post<any>(appURL, activeIngredientDetails);
  }
  saveProductDetails(productDetails: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.SAVE_PRODUCT);
    return this.http.post<any>(appURL, productDetails);
  }
  saveLegal(legalHtmlContent: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.SAVE_LEGAL);
    return this.http.post<any>(appURL, legalHtmlContent);
  }
  //Technical Guide
  checkFileStatusInDB(fileName: any, operations: number, entityId: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.CHECK_FILE_STATUS) + '?fileName=' + fileName + '&operations=' + operations + '&entityId=' + entityId;
    return this.http.get(appURL);
  }
  checkFileStatusInS3(fileUpload: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.CHECK_FILE_STATUS_S3);
    return this.http.post(appURL, fileUpload);
  }
  postFile(fileUpload: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.POST_PDF_FILE);
    return this.http.post(appURL, fileUpload);
  }
  InvalidateImageInS3Bucket(fileUpload: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.INVALIDATE_IMAGE_S3);
    return this.http.post(appURL, fileUpload);
  }
  SaveTempFileToDB(fileUpload: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.SAVE_TEMP_FILE);
    return this.http.post(appURL, fileUpload);
  }
  EntityContent(fileUpload: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.ENTITY_CONTENT);
    return this.http.post(appURL, fileUpload);
  }
  Associationlist(fileUpload: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.ASSOCIATION_LIST);
    return this.http.post(appURL, fileUpload);
  }
  DeleteDocument(fileUpload: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.DELETE_DOCUMENT);
    return this.http.post(appURL, fileUpload);
  }
  DeleteMedia(entityID: number): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.DELETE_MEDIA) + '?entityID=' + entityID;
    return this.http.delete(appURL);
  }
  saveTechnicalGuide(techGuideData: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.SAVE_TECH_GUIDE_DATA);
    return this.http.post<any>(appURL, techGuideData);
  }
  getTechnicalGuideData(): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.GET_TECH_GUIDE_DATA) + '?infoType=page_data';
    return this.http.get<any>(appURL);
  }
  getTechGuide(techGuideId: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.GET_TECH_GUIDE) + '/' + techGuideId + '?infoType=guide_by_id';
    return this.http.get<any>(appURL);
  }
  ActiveDeactiveTechGuide(techGuideId: any, status: any , activeObject : any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.ACTIVE_DEACTIVE_TECH_GUIDE) + '/' + techGuideId + '?isActive=' + status;
    return this.http.post<any>(appURL, activeObject);
  }
  DeleteTechGuide(techGuideId: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.TECHNICAL_GUIDE.DELETE_TECH_GUIDE) + '/' + techGuideId;
    return this.http.post<any>(appURL, techGuideId);
  }
}
